import { generateMedia } from 'styled-media-query'

export default generateMedia({
  xxsmall: '350px',
  xsmall: '575.98px',
  small: '767.98px',
  medium: '991.98px',
  large: '1199.98px',
  modal: '944.98px',
  xlarge: '1300px',
})

export const screenSizes = {
  xxsmall: 350,
  xsmall: 575.98,
  small: 767.98,
  medium: 991.98,
  large: 1199.98,
  modal: 944.98,
  xlarge: 1300,
}
